import React from 'react';

import styles from './QuizResult.module.scss';
import Label from '../../context/Label/Label';
import Icon from '../../UI/Icon/Icon';
import QuizResultOverall from './QuizResultOverall';
import Alert from '../../UI/Alert/Alert';

type QuizResultProps = {
  result: {
    score: number;
    totalAnsweredCorrectly: number;
    totalAnswered: number;
  };
  passingScore: number;
  hasPassed: boolean;
  globalState: any;
  cannotProgressWhenFailed: boolean;
  resourceId: string;
  showResults: boolean;
};

function QuizResult({
  result,
  hasPassed,
  passingScore,
  cannotProgressWhenFailed,
  globalState,
  resourceId,
  showResults,
}: QuizResultProps) {
  return (
    <div className={styles.Quiz__result}>
      {showResults ? (
        <h2>
          <Label>Results</Label>
        </h2>
      ) : (
        <Alert className={styles.Quiz__alert_completed}>
          <Label>Quiz completed</Label>
        </Alert>
      )}
      <div
        className={styles.Quiz__result__detail}
        style={{ display: !showResults ? 'none' : undefined }}
      >
        <span>
          <Label>Score</Label>
        </span>
        <span data-testid="quiz-score">{result?.score}%</span>
        <span>
          {result?.totalAnsweredCorrectly} <Label>of</Label>{' '}
          {result?.totalAnswered} <Label>correct</Label>
        </span>
        {passingScore ? (
          <div
            className={[
              styles.Quiz__result__passingScore,
              hasPassed
                ? styles.Quiz__result__passingScore__passed
                : styles.Quiz__result__passingScore__failed,
            ].join(' ')}
          >
            <span>
              <Label>Passing score</Label>: {passingScore}%
            </span>
            <Icon
              icon={hasPassed ? 'check-circle' : 'times-circle'}
              className={styles.Quiz__result__passingScore__icon}
            />
          </div>
        ) : null}
        {!(cannotProgressWhenFailed && !hasPassed) && (
          <QuizResultOverall
            resourceId={resourceId}
            showResults={showResults}
            globalState={globalState}
          />
        )}
      </div>
    </div>
  );
}

export default QuizResult;
